import React from 'react';
import { Box, Container, Grid, Button, Link as MuiLink, Stack } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled } from '@mui/system';

import logo from '../assets/logo.svg';
import headerBg from '../assets/headerbg.svg';
import iconLink from '../assets/link.svg';
import iconFace from '../assets/face.svg';
import iconWcag from '../assets/wcag.svg';

const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  width: '100%',
  height: '140px',
  zIndex: 1100,
  backgroundColor: '#1C353A',

  // na mobile (≤600px) zamiast fixed używamy sticky
  [theme.breakpoints.down('sm')]: {
    position: 'sticky',
    top: 0,
    height: 'auto',
    width: '100%',
    overflow: 'hidden',
  },
}));

const IconLink = styled('img')({
  width: 24,
  height: 24,
  position: 'relative',
  cursor: 'pointer',
  transition: 'transform 0.3s ease, filter 0.3s ease',
  '&:hover': {
    transform: 'scale(1.2)',
    filter: 'brightness(1.2)',
  },
});

export default function Header({ onToggleContrast }) {
  return (
  <HeaderWrapper component="header" role="banner">
    <Container
      disableGutters
      sx={{
        height: '100%',
        maxWidth: '1536px !important',
        width: '100%',
        mx: 'auto',
        px: 3,
        backgroundImage: `url(${headerBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '@media (max-width: 1200px)': {
          maxWidth: '100% !important',
          padding: '0',
          backgroundImage: 'none',
        },
      }}
    >
      <Grid container columns={12}   
      sx={{
    height: '100%',
    flexDirection: { xs: 'column', lg: 'row' }, // kolumnowo na xs, w rzędzie od lg+
    flexWrap:      { xs: 'nowrap', lg: 'wrap' }, // bez wrap na xs, z wrap od lg+
  }}>
        {/* Logo: 2 kolumny */}
        <Grid
          item
          size={{ xs: 2, lg: 2 }}

          sx={{
            paddingTop: { xs: '8px', lg: 0 },
            paddingBottom: { xs: '8px', lg: 0 },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <a href="/#top" style={{ display: 'inline-block' }}>
            <Box
              component="img"
              src={logo}
              alt="Bimetria logo"
              sx={{ 
                paddingLeft: { xs: '15px', lg: 0 },
                height: { xs: 50, lg: 90 }, 
                width: 'auto' }}
            />
          </a>
        </Grid>

        {/* Menu: 8 kolumn na xs, 7 na lg+ */}
        <Grid
          item
          size={{ xs: 9, lg: 7 }}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', lg: 'center' },
            alignItems: 'flex-start',       // Wyrównanie do góry
            height: '100%',
            position:      { xs: 'absolute', lg: 'relative' },
            top: { xs: '10px', lg: 'initial' }, // Przesunięcie w dół na xs
            right: { xs: '0', lg: 'initial' }, // Przesunięcie w dół na xs
            height: { xs: '50px', lg: 'auto' }, // Wysokość na xs
          }}
        >
          <Box
            sx={{
              height: '50%',
              px: 3,
              py: 1.5,
              color: 'white',
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Stack direction="row" spacing={4}>
              <MuiLink href="/#about" underline="hover" color="inherit" sx={{
  fontWeight: 500,
  fontSize: { xs: '13px', lg: '16px' }
}}
>
                O usłudze
              </MuiLink>
              <MuiLink href="/#package" underline="hover" color="inherit" sx={{
  fontWeight: 500,
  fontSize: { xs: '13px', lg: '16px' }
}}
>
                Pakiety
              </MuiLink>
              <MuiLink href="/#section8" underline="hover" color="inherit" sx={{
  fontWeight: 500,
  fontSize: { xs: '13px', lg: '16px' }
}}
>
                Kontakt
              </MuiLink>
            </Stack>
          </Box>
        </Grid>

        {/* Przycisk + ikony: 2 kolumny na xs, 3 na lg+ */}
        <Grid
          item
          size={{ xs: 12, lg: 3 }}
          sx={{
            backgroundColor: { xs: '#FA405A', lg: 'none' },
            display: 'flex',
            justifyContent: { xs: 'start', lg: 'flex-end' },
            alignItems: 'center',
          }}
        >
          <Stack alignItems="flex-end" spacing={0}
          sx={{
            paddingLeft: { xs: '15px', lg: 0 },
            mt : { xs: '2px', lg: 0 },
            display: 'flex',
            justifyContent: { xs: 'start', lg: 'flex-end' },
            alignItems: 'center',
            flexDirection: { xs: 'row', lg: 'column' },
            gap: { xs: '40px', lg: 'initial' },
          }}>
            <Button
              href="https://app.bimetria.com"
                      target="_blank"
              variant="contained"
              color="primary"
              size="large"
              endIcon={<ChevronRightIcon />}
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                fontSize: { xs: '16px', lg: '18px' },
                px: { xs: 2, lg: 3 },
                py: { xs: 0.5, lg: 1 },
                my: { xs: 1, lg: 0.5}
              }}
            >
              Aplikacja Bimetria
            </Button>
            <Box sx={{mt: {xs: '0px',lg:'20px' }}}>
              <Stack direction="row" spacing={2}>
                <a href="//linkedin.com/company/bimetria/" target="_blank"><IconLink src={iconLink} alt="Link" /></a>
                {/* <a href="#package"><IconLink src={iconFace} alt="Facebook" /></a> */}
                {/* WCAG: wywołanie toggleContrast */}
                <Box component="span" onClick={onToggleContrast}>
                  <IconLink src={iconWcag} alt="WCAG" />
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  </HeaderWrapper>
); }